import { VerificationStatus } from "shared/types";
import { Check, XClose } from "untitledui-js-base";
import { WithIcon } from "views/applications-id/components/ApplicantsTable/components/WithIcon";
import { EmptyCellIcon } from "./TableBodySections/components/EmptyCellIcon";

interface IDVstatus {
  status: VerificationStatus;
}

export const IDVstatus = ({ status }: IDVstatus) => {
  switch (status) {
    case VerificationStatus.ManuallyApproved:
    case VerificationStatus.FinishedByOverridden:
      return (
        <WithIcon
          Icon={Check}
          iconClassName="stroke-success-600"
          className="text-content-1000"
        >
          Pass{" "}
          <span className="ml-2 text-content-200 font-medium text-sm">
            (Manually overridden)
          </span>
        </WithIcon>
      );
    case VerificationStatus.Failed:
      return (
        <WithIcon
          Icon={XClose}
          iconClassName="stroke-danger-600"
          className="text-content-1000"
        >
          Fail
        </WithIcon>
      );
    case VerificationStatus.Finished:
    case VerificationStatus.Verified:
      return (
        <WithIcon
          Icon={Check}
          iconClassName="stroke-success-600"
          className="text-content-1000"
        >
          Pass
        </WithIcon>
      );
    case VerificationStatus.FinishedWithWarnings:
      return (
        <WithIcon
          Icon={Check}
          iconClassName="stroke-warning-600"
          className="text-content-1000"
        >
          Pass with warnings
        </WithIcon>
      );
    default:
      return <EmptyCellIcon />;
  }
};
